import { waitFor } from './toolPending'

/**
 * Дождаться, пока плитки слоя действительно лягут на карту.
 *
 * Кадр серии снимается с полотна: чего на полотне нет, того не будет и в
 * архиве. Полагаться тут на паузу нельзя — 18.08.2026 батиметрия приехала
 * полосой шириной ровно в один тайл, потому что её плитки рисуются ЛЕНИВО из
 * GEBCO по первому запросу: двадцать штук кадра заняли 17 секунд, а серия
 * ждала полторы и сняла что было. Отказ был немым: картинка правдоподобная,
 * файл параметров про неё молчал.
 *
 * Спрашиваем `areTilesLoaded()`, а не событие `idle`: `idle` ждёт ещё и конца
 * анимаций, а над картой живут суда, снос и мигающие метки — на такой карте
 * его можно не дождаться вовсе.
 */

export interface TileMap {
  /** MapLibre: все ли плитки видимой части загружены. */
  areTilesLoaded(): boolean
}

/**
 * Условие, которому верим только после `times` подтверждений подряд.
 *
 * Между подменой адреса тайлов и сбросом кэша MapLibre ещё отвечает «всё
 * загружено» — про ПРЕДЫДУЩИЙ слой. Приняв первый ответ, серия снимала бы
 * старый растр под новой подписью: ошибка, которую по картинке не увидеть.
 */
export function stably(ready: () => boolean, times: number): () => boolean {
  let seen = 0
  return () => {
    seen = ready() ? seen + 1 : 0
    return seen >= times
  }
}

/**
 * `false` — сдались по потолку. Это не отказ серии: кадр снимается как есть,
 * а строка в файле параметров говорит человеку, что слой не дорисовался.
 */
export function waitTilesReady(
  map: TileMap | null | undefined,
  opts: { timeoutMs: number; pollMs: number; stable?: number; sleep?: (ms: number) => Promise<void> },
): Promise<boolean> {
  if (!map) return Promise.resolve(true)
  return waitFor(stably(() => map.areTilesLoaded(), opts.stable ?? 2), opts)
}
